import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {DetailPage} from './pages/DetailPage.tsx';
import {RequirePermission} from '../../utils/RequirePermission.tsx';
import {rbacActions} from '../../config/rbac/actions.ts';

// FNP-861: READ-ONLY module — index and detail only. No add or edit route.
export const SyntheticUsersLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action={rbacActions.ListSyntheticUsers}>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id'
                element={
                    <RequirePermission action={rbacActions.GetSyntheticUser}>
                        <DetailPage/>
                    </RequirePermission>
                }
            />
        </Routes>
    );
};
